import { getFeatureFlags } from 'core/flow-control';
import { mobileSupportPageSignal } from 'features/mobile-report/state/mobile-report.signals';
import { MobileSupportPagesType } from 'features/mobile-report/types/types';

export const openMobileSupportPage = (page: MobileSupportPagesType) => {
    const { enable_new_modules_mobile } = getFeatureFlags();

    if (!enable_new_modules_mobile) return;

    mobileSupportPageSignal.value = page;
};
